import { render, staticRenderFns } from "./DisplayIcon.vue?vue&type=template&id=38a07ab4&"
import script from "./DisplayIcon.vue?vue&type=script&lang=js&"
export * from "./DisplayIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports